export const isHexColor = (str: string) => {
  const hexRegex =
    /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/;

  return hexRegex.test(str);
};

export const hexToRgba = (
  hex: string,
  opacity = 1,
  defaultReturnValue = "transparent",
) => {
  if (!isHexColor(hex)) return defaultReturnValue;

  let r: number | undefined,
    g: number | undefined,
    b: number | undefined,
    a: number | undefined;

  if (hex.length === 9) {
    r = Number.parseInt(hex.substring(1, 3), 16);
    g = Number.parseInt(hex.substring(3, 5), 16);
    b = Number.parseInt(hex.substring(5, 7), 16);
    a = Number.parseInt(hex.substring(7, 9), 16) / 255;
  } else if (hex.length === 7) {
    r = Number.parseInt(hex.substring(1, 3), 16);
    g = Number.parseInt(hex.substring(3, 5), 16);
    b = Number.parseInt(hex.substring(5, 7), 16);
    a = opacity;
  } else if (hex.length === 4) {
    r = Number.parseInt(hex[1] + hex[1], 16);
    g = Number.parseInt(hex[2] + hex[2], 16);
    b = Number.parseInt(hex[3] + hex[3], 16);
    a = opacity;
  }

  return `rgba(${r},${g},${b},${a})`;
};
